import { BsComponentBundle } from 'booksprout-app'
import { boot } from 'quasar/wrappers'

// Quasar 2 hands `boot` the app, not the Vue constructor.
export default boot(({ app }) => {
  app.use(BsComponentBundle)
})
